
export enum NotificationStatusEnum
{
     Read = 1,
     UnRead = 2,
     Deleted = 3,
}

export enum NotificationTemplateType
{
Email =1,
SMS = 2,
PushNotification = 3,
SignalR = 4
}
